import { FormValues } from "./types";

export const inputsSpacing = 3;

export const names: Record<keyof FormValues, string> = {
  description: "description",
  offeringId: "offeringId",
};
